import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// import { ModalComponent } from '../../../shared/components/modal/modal.component';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
declare var ga: any;

@Component({
  selector: 'app-access-account-section',
  templateUrl: './access-account-section.component.html',
  styleUrls: ['./access-account-section.component.scss'],
  providers: [LoginService, ErrorHandler, DataStorageService]
})
export class AccessAccountSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/access-account');
      ga('send', 'pageview');
    }
  }

}
